'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _always2 = require('ramda/src/always');

var _always3 = _interopRequireDefault(_always2);

var _ifElse2 = require('ramda/src/ifElse');

var _ifElse3 = _interopRequireDefault(_ifElse2);

var _templateObject = _taggedTemplateLiteral(['margin:0;font-size:', ';', ';'], ['margin:0;font-size:', ';', ';']),
    _templateObject2 = _taggedTemplateLiteral(['color:', ';'], ['color:', ';']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _isString = require('../utils/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getBaseComponent = (0, _ifElse3.default)(_isString2.default, (0, _always3.default)('p'), (0, _always3.default)('div'));

var Component = function Component(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(getBaseComponent(children), otherProps, children);
};
Component.displayName = 'Component';
Component.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var P = (0, _styledComponents2.default)(Component)(_templateObject, function (props) {
  return props.theme.fontSize.p;
}, function (props) {
  return props.color && (0, _styledComponents.css)(_templateObject2, props.theme.color[props.color]);
});

P.displayName = 'P';
P.propTypes = {
  color: _propTypes2.default.string
};

exports.default = P;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/P/P.js
// module id = 475
// module chunks = 4